module.exports = __webpack_public_path__ + "img/twitter.e90818ef.svg";